import get from 'lodash/get'
import Spinner from '~/components/ui/spinner'
import StatefulButton from '~/components/ui/stateful-button'
import ControlsForm from '~/libs/forms/mixins/controls-form'
import { pricePoints } from '~/modules/loans/config'
import MicroloanModel from '~/modules/loans/models/microloan'
import { money } from '~/utils/format'

export default {
  mixins: [
    ControlsForm,
  ],
  components: {
    Spinner,
    StatefulButton,
  },
  props: {
    currency: {
      type: String,
      default: 'GBP',
    },
    loanId: {
      type: Number,
      required: true,
    },
    remaining: {
      type: Number,
      required: true,
    },
    entrepreneurDisplayName: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      basketRoute: {
        name: 'basket:frontend:index',
      },
    }
  },
  computed: {
    availablePricePoints () {
      if (this.remaining < 1500) return []

      // Find an index of the largest pricepoint that is still below the
      // value of the remaining amount.
      let i = 0

      for (i; i < pricePoints.length; i++) {
        if (this.remaining < pricePoints[i]) {
          break
        }
      }

      return pricePoints.slice(0, i)
    },
    availableOptions () {
      return this.availablePricePoints.map(pp => ({
        value: pp,
        label: money(pp, this.currency).replace(/\.00$/, ''),
      }), this)
    },
    formattedAmount () {
      const amount = this.model ? this.model.amount : 0

      return money(amount, this.currency)
    },
    isInBasket () {
      /** @type {Microloan[]} */
      const microloansInBasket = get(this.$store, ['getters', 'basket/microloans'], [])

      return microloansInBasket.some(m => m.loanId === this.loanId, this)
    },
    selectProps () {
      return {
        disabled: this.requestPending,
        name: 'amount',
        options: this.availableOptions,
        required: true,
      }
    },
  },
  methods: {
    createModel () {
      return new MicroloanModel({
        vm: this,
        loanId: this.loanId,
        amount: this.determineCurrentAmount(),
      })
    },
    determineCurrentAmount () {
      if (this.isInBasket) {
        const microloansInBasket = get(this.$store, ['getters', 'basket/microloans'], [])
        const microloan = microloansInBasket.find(m => m.loanId === this.loanId, this)

        return this.$get(microloan, 'amount', 0)
      }

      return this.remaining > 1500 ? 1500 : this.remaining
    },
  },
}
